<template>
  <v-dialog v-model="dialog.showConfig" width="600">
    <v-layout max-width class="flex-column">
      <div class="white">
        <div
          class="flex-y-center flex-justify-between px-4 py-2 white mb-3"
          style=""
        >
          <div>
            <v-btn
              dark
              small
              color="#00bea9"
              depressed
              min-width="32"
              height="30"
              style="padding: 0 8px"
              @click="addShow"
            >
              <v-icon size="16">mdi-plus</v-icon>新增
            </v-btn>
          </div>
          <div class="flex-y-center" />
        </div>
        <v-data-table
          :headers="headers"
          :items="list"
          :items-per-page="search.pageSize"
          class="pb-5 max-width pa-4"
          hide-default-footer
          item-key="id"
          no-data-text="暂无查询数据"
          :loading="listLoading"
        >
          <template v-slot:item.rowIndex="{ index }">
            {{ index + 1 + search.pageSize * (search.pageNo - 1) }}
          </template>
          <template v-slot:item.tagColor="{ item }">
            <div
              style="width: 50px; height: 16px"
              :style="{ background: item.tagColor }"
            />
          </template>
          <template v-slot:item.active="{ item }">
            <a class="mr-2" @click="showEdit(item)">编辑</a>
            <a class="mr-2" @click="showDel(item.id)">删除</a>
          </template>
        </v-data-table>
        <div class="mt-2 pr-2 mb-5 max-width flex-justify-end">
          <pagination
            v-model="search.pageNo"
            :size="search.pageSize"
            :total="total"
            @input="getList()"
            @changePageSize="changePageSize"
          />
        </div>
      </div>
      <!-- 新增 编辑 组织角色 -->
      <v-dialog v-model="dialog.show" width="600">
        <form @submit.prevent="submitAdd()">
          <v-card>
            <v-card-title class="font-weight-bold">{{
              dialog.id ? '编辑上传角色' : '新增上传角色'
            }}</v-card-title>
            <v-divider />
            <v-card-text class="py-5">
              <div class="flex-1 flex-column overflow-auto mt-7 px-12">
                <div class="mb-6 flex-align-start">
                  <div
                    class="form-title flex-0 flex-shrink-0 flex-justify-end mt-2"
                  >
                    <span class="red--text ml-1">*</span>审批顺序：
                  </div>
                  <input
                    v-model="dialog.data.approvalSequence"
                    class="flex-1 default-input"
                    style="width: 300px"
                    required
                    type="number"
                    @blur="
                      () =>
                        dialog.data.approvalSequence < 0
                          ? (dialog.data.approvalSequence = 0)
                          : ''
                    "
                  >
                </div>
                <div class="mb-6 flex-align-start">
                  <div
                    class="form-title flex-0 flex-shrink-0 flex-justify-end mt-2"
                  >
                    <span class="red--text ml-1">*</span>项目角色：
                  </div>
                  <form-item
                    v-model="dialog.data.roleId"
                    style="width: 500px"
                    :options="roleList"
                    placeholder="项目角色"
                    dense
                    required
                    type="select"
                    :item-text="`roleName`"
                    :item-key="`id`"
                  />
                </div>
                <div class="mb-6 flex-align-start">
                  <div
                    class="form-title flex-0 flex-shrink-0 flex-justify-end mt-2"
                  >
                    <span class="red--text ml-1">*</span>审批方式：
                  </div>
                  <form-item
                    v-model="dialog.data.type"
                    style="width: 500px"
                    required
                    :options="[
                      { text: '或签', value: '或签' },
                      { text: '会签', value: '会签' },
                    ]"
                    placeholder="审批方式"
                    dense
                    type="select"
                  />
                </div>
              </div>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <div class="max-width flex-y-center flex-justify-between">
                <div class="flex-1 flex-justify-end">
                  <v-btn
                    width="80"
                    height="30"
                    class
                    depressed
                    @click="dialog.show = false"
                  >取消</v-btn>
                  <v-btn
                    width="80"
                    :loading="btnLoading"
                    type="submit"
                    class="ml-3"
                    height="30"
                    color="primary"
                    depressed
                  >确定</v-btn>
                </div>
              </div>
            </v-card-actions>
          </v-card>
        </form>
      </v-dialog>
      <!-- 新增 编辑 组织角色 end -->
    </v-layout>
  </v-dialog>
</template>

<script>
  export default {
    data() {
      return {
        roleList: [], // 组织角色数组列表
        search: {
          pageSize: 10,
          pageNo: 1,
          data: {}
        },
        total: 0,
        type: '',
        headers: [
          { text: '序号', value: 'rowIndex', width: '50', sortable: false },
          { text: '审批顺序', value: 'approvalSequence' },
          { text: '项目角色', value: 'roleName' },
          { text: '审批方式', value: 'type' },
          { text: '操作', value: 'active', sortable: false }
        ],
        list: [],
        listLoading: false,
        btnLoading: false,
        // color:"#D53434",
        dialog: {
          show: false,
          showConfig: false,
          colorShow: false,
          type: '',
          color: '',
          data: {

          },
          dataConfig: {

          }
        }
      }
    },
    mounted() {
      this.getRoleList();
    },
    methods: {
      open(item) {
        this.dialog.showConfig = true
        this.dialog.dataConfig = { ...item }
        this.search.data.reviewId = item.id
        this.initList()
      },
      // 获取角色 列表
      getRoleList() {
        const search = { roleCategory: '1' };
        search.pageNo = 1;
        search.pageSize = 999;
        const param = new URLSearchParams();
        for (const i in search) {
          param.append(i, search[i] || '');
        }

        this.$http
                .get(this.$api.roleList, { data: { ...search } })
                .then((res) => {
                  this.roleList = (res.result && res.result.records) || [];
                })
                .catch(() => {
                });
      },
      initList() {
        this.search.pageNo = 1
        this.getList()
      },
      // 改变每页的条数
      changePageSize(e) {
        this.search.pageSize = e
        this.search.pageNo = 1
        this.$forceUpdate()
        this.getList()
      },
      getList() {
        this.listLoading = true
        const search = { ...this.search.data }
        search.pageSize = this.search.pageSize
        search.pageNo = this.search.pageNo
        this.$http.get(this.$api.cReviewConfigurationList, { data: { ...search }}).then(res => {
          this.listLoading = false
          this.list = res.result.records || []
          this.total = res.result.total
        })
      },
      // 确认删除弹窗
      showDel(id) {
        this.$confirm({ text: '是否确认删除？' }).then((vm) => {
          vm.loading = true
          this.$http.delete(this.$api.cReviewConfigurationDelete, { data: { id: id }}).then(res => {
            vm.show = false
            vm.loading = false
            this.$message.success(res.message)
            this.initList()
          }).catch(() => {
            vm.show = false
            vm.loading = false
          })
        }).catch(() => {})
      },
      // 编辑弹窗
      showEdit(item) {
        this.dialog.show = true
        this.dialog.data = { ...item }
      },
      addShow() {
        this.dialog.show = true
        this.dialog.data = { roleIds: [] }
      },
      submitAdd() {
        let url = this.$api.cReviewConfigurationAdd
        let method = 'post'
        if (this.dialog.data.id) {
          url = this.$api.cReviewConfigurationEdit
          method = 'put'
        }
        this.btnLoading = true
        this.dialog.data.reviewId = this.dialog.dataConfig.id
        this.$http[method](url, { data: { ...this.dialog.data }}).then(res => {
          this.$message.success(res.message)
          this.dialog.show = false
          this.dialog.data = {}
          this.btnLoading = false
          this.getList()
        }).catch(() => {
          this.dialog.show = false
          this.dialog.data = {}
          this.btnLoading = false
        })
        .catch(() => {
          this.dialog.show = false;
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-title {
  width: 100px;
  color: #777;
}
</style>
